import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { HomeHeroPotencia, ParqueVehicular2, Maquinaria1945, Maquinaria1947, Maquinaria1963, Maquinaria1964, Maquinaria1985, Maquinaria1988, Maquinaria2004, Maquinaria2006, Maquinaria2016, Maquinaria2017, Maquinaria2018, Maquinaria2019, Maquinaria2020_1, Maquinaria2020_2 } from '../../assets/images';

const About = () => {
  const timeline = [
    {
      year: '1945',
      title: 'Los primeros años',
      desc: 'Joseph Cyril Bamford inicia el negocio utilizando repuestos y chatarra excedentes de la Segunda Guerra Mundial. El remolque basculante JCB se fabricó con ruedas y neumáticos de un avión de combate Grumman Hellcat.',
      img: Maquinaria1945,
      alt: 'JCB 1945 - Primer remolque basculante agrícola fabricado por Joseph Cyril Bamford'
    },
    {
      year: '1947',
      title: 'Una Gran innovación',
      desc: 'En poco menos de tres años, Joseph Bamford lanza Major Loader. Diseñado para la versatilidad, es el primer cargador frontal industrial de Europa.',
      img: Maquinaria1947,
      alt: 'JCB Major Loader 1947 - Primer cargador frontal industrial de Europa'
    },
    {
      year: '1963',
      title: 'Lanzamiento de la 3C',
      desc: 'Se lanza la retroexcavadora JCB 3C, un reconocido clásico del diseño que marcaría un antes y después en la industria.',
      img: Maquinaria1963,
      alt: 'Retroexcavadora JCB 3C 1963 - Clásico del diseño industrial'
    },
    {
      year: '1964',
      title: 'Primera excavadora de orugas',
      desc: 'La excavadora sobre orugas JCB 7 se fabricó bajo licencia de Warner Swasey, propulsada por un motor Ford, con conjuntos de tren de rodaje fabricados por JCB.',
      img: Maquinaria1964,
      alt: 'Excavadora JCB 7 de orugas 1964 - Primera excavadora sobre orugas JCB'
    },
    {
      year: '1985',
      title: 'El mejor vendido',
      desc: 'Se lanza la retroexcavadora 3CX Sistemaster, que pasó a ser la retroexcavadora de mayor venta en la historia de JCB. Se celebra la producción de la máquina número 100.000.',
      img: Maquinaria1985,
      alt: 'Retroexcavadora JCB 3CX Sitemaster 1985 - La retroexcavadora más vendida en la historia de JCB'
    },
    {
      year: '1988',
      title: 'La retro más rápida del mundo',
      desc: 'El famoso JCB GT, propulsado por un Chevrolet V8, era capaz de alcanzar los 160 km/h. Cautivó a la multitud en el Gran Premio de Gran Bretaña.',
      img: Maquinaria1988,
      alt: 'JCB GT 1988 - La retroexcavadora más rápida del mundo con motor Chevrolet V8'
    },
    {
      year: '2004',
      title: 'Máquina número 500.000',
      desc: 'Los empleados se reúnen en la sede mundial para celebrar la producción de la máquina número 500.000. Se habían necesitado poco menos de 60 años para alcanzar ese hito.',
      img: Maquinaria2004,
      alt: 'JCB 2004 - Celebración de la máquina número 500.000 fabricada'
    },
    {
      year: '2006',
      title: 'Récord DIESELMAX',
      desc: 'El JCB DIESELMAX, propulsado por dos motores diésel JCB 444 de 1500 hp, alcanzó 350.092 mph en Bonneville Salt Flats, estableciendo un récord mundial de velocidad en tierra.',
      img: Maquinaria2006,
      alt: 'JCB DIESELMAX 2006 - Récord mundial de velocidad en tierra en Bonneville Salt Flats'
    },
    {
      year: '2016',
      title: 'La primera excavadora verdadera de ruedas',
      desc: 'Lord Bamford imaginó el JCB Hydradig I 10W como una solución innovadora para cinco desafíos clave: visibilidad, estabilidad, maniobrabilidad, movilidad y capacidad de servicio.',
      img: Maquinaria2016,
      alt: 'JCB Hydradig 2016 - Primera excavadora verdadera de ruedas con visión de 360 grados'
    },
    {
      year: '2017',
      title: 'El nuevo JCB Teleskid',
      desc: 'El JCB Teleskid es el primer minicargador con una sola pluma telescópica. Puede levantar más altura, llegar más lejos y excavar más profundo que cualquier otra minicargadora.',
      img: Maquinaria2017,
      alt: 'JCB Teleskid 2017 - Primer minicargador con pluma telescópica del mundo'
    },
    {
      year: '2018',
      title: 'Primera máquina eléctrica',
      desc: 'JCB presenta su primera miniexcavadora eléctrica, la JCB 19C-1E. Una vez completamente cargada, está lista para trabajar un día completo en el sitio de construcción.',
      img: Maquinaria2018,
      alt: 'JCB 19C-1E 2018 - Primera miniexcavadora eléctrica de JCB'
    },
    {
      year: '2018',
      title: 'El tractor más rápido del mundo',
      desc: 'El JCB Fastrac Two establece un récord Guinness como el tractor más rápido del mundo con una velocidad máxima de 153,771 mph (247,470 kph).',
      img: Maquinaria2019,
      alt: 'JCB Fastrac Two 2018 - Tractor más rápido del mundo con récord Guinness'
    },
    {
      year: '2020',
      title: 'Retroexcavadora n° 750.000',
      desc: 'JCB marca la producción de la retroexcavadora número 750.000. Con un nuevo diseño sorprendente y nuevas características, establece nuevos estándares en facilidad de uso, comodidad y eficiencia.',
      img: Maquinaria2020_1,
      alt: 'Retroexcavadora JCB 750.000 2020 - Hito de producción con nuevo diseño'
    },
    {
      year: '2020',
      title: 'Primera excavadora de hidrógeno',
      desc: 'JCB desarrolla la primera excavadora impulsada por hidrógeno de la industria de la construcción. La excavadora 220X de 20 toneladas se ha sometido a rigurosas pruebas durante más de 12 meses.',
      img: Maquinaria2020_2,
      alt: 'JCB 220X de hidrógeno 2020 - Primera excavadora de hidrógeno de la industria'
    }
  ];

  return (
    <div className="about-container">
      <Helmet>
        <title>Sobre Nosotros | JCB Azteca</title>
        <meta name="description" content="Conoce la historia, valores y el respaldo de JCB Azteca. Más de 75 años de innovación en maquinaria JCB con distribución en el sureste de México: Villahermosa, Mérida, Veracruz y Puerto Morelos." />
        <meta name="keywords" content="JCB Azteca historia, sobre JCB, distribuidor JCB México, historia JCB, retroexcavadora JCB, maquinaria JCB sureste México" />
        <link rel="canonical" href="https://azteca-site.org/about" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Sobre Nosotros | JCB Azteca" />
        <meta property="og:description" content="Conoce la historia y el respaldo de JCB Azteca, distribuidor autorizado en el sureste de México." />
        <meta property="og:url" content="https://azteca-site.org/about" />
        <meta property="og:image" content="https://azteca-site.org/og/sobre-nosotros-jcb-azteca.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="JCB Azteca - Más de 75 años de innovación en maquinaria JCB" />
        <meta property="og:locale" content="es_MX" />
        <meta property="og:site_name" content="JCB Azteca" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sobre Nosotros | JCB Azteca" />
        <meta name="twitter:description" content="Más de 75 años de innovación en maquinaria JCB." />
        <meta name="twitter:image" content="https://azteca-site.org/og/sobre-nosotros-jcb-azteca.jpg" />
        <meta name="twitter:image:alt" content="JCB Azteca - Historia e innovación" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "AboutPage",
                "name": "Sobre Nosotros | JCB Azteca",
                "url": "https://azteca-site.org/about",
                "description": "Historia, valores y respaldo de JCB Azteca en el sureste de México.",
                "inLanguage": "es-MX",
                "isPartOf": {
                  "@type": "WebSite",
                  "name": "JCB Azteca",
                  "url": "https://azteca-site.org/"
                },
                "about": {
                  "@type": "Organization",
                  "name": "JCB Azteca",
                  "url": "https://azteca-site.org/",
                  "foundingDate": "1945",
                  "description": "Distribuidor autorizado JCB en el sureste de México.",
                  "areaServed": ["Tabasco", "Yucatán", "Veracruz", "Quintana Roo"]
                },
                "breadcrumb": {
                  "@type": "BreadcrumbList",
                  "itemListElement": [
                    {
                      "@type": "ListItem",
                      "position": 1,
                      "name": "Inicio",
                      "item": "https://azteca-site.org/"
                    },
                    {
                      "@type": "ListItem",
                      "position": 2,
                      "name": "Sobre Nosotros",
                      "item": "https://azteca-site.org/about"
                    }
                  ]
                }
              }
            ]
          })}
        </script>
      </Helmet>

      <nav className="text-sm mb-0 absolute top-24 left-0 right-0 z-20 max-w-[1680px] mx-auto px-6 sm:px-12" aria-label="Breadcrumb">
        <Link to="/" className="text-white/60 hover:text-white transition-colors">Inicio</Link>
        <span className="mx-2 text-white/40">/</span>
        <span className="text-white font-medium">Sobre Nosotros</span>
      </nav>

      <section className="relative w-full min-h-[70vh] max-h-[800px] bg-dark-primary overflow-hidden flex items-center">
        <div className="absolute inset-0 z-0">
          <img
            alt="JCB 1945 - Primer remolque basculante agrícola de Joseph Cyril Bamford"
            title="JCB Azteca | Historia desde 1945"
            className="w-full h-full object-cover object-center filter brightness-[0.5] contrast-[1.1]"
            src={Maquinaria1945}
            width="1920"
            height="1080"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-dark-primary via-dark-primary/40 to-black/30"></div>
        </div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-6 sm:px-12 py-20">
          <div className="max-w-3xl">
            <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl font-semibold text-white tracking-tight-headline leading-[1.05] uppercase">
              Una historia de innovación y trabajo
            </h1>
            <p className="mt-5 text-base sm:text-lg text-neutral-300 font-light max-w-xl leading-relaxed">
              La historia de JCB es una historia de innovación, ambición y mucho trabajo. Desde sus modestos comienzos en 1945 como constructora de remolques basculantes agrícolas hasta llegar a ser la empresa de fabricación líder en el mundo en la que se ha convertido, JCB ha ido superando continuamente sus límites gracias a nuestro deseo de ser los mejores.
            </p>
          </div>
        </div>
      </section>

      <section className="w-full py-28 sm:py-36 bg-surface-subtle border-y border-border-subtle">
        <div className="max-w-[1680px] mx-auto px-6 sm:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
            <div className="lg:col-span-5">
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold uppercase tracking-tight-headline text-dark-primary leading-tight">
                <span className="text-jcb-yellow">#1</span> Distribución y respaldo en el Sureste de México
              </h2>
              <div className="mt-6 space-y-4 text-base text-text-muted leading-relaxed">
                <p>
                  En JCB Azteca somos líderes en ingeniería y distribución de equipos de construcción en el Sureste Mexicano.
                </p>
                <p>
                  Somos proveedores de maquinaria para las necesidades de diferentes sectores, entre ellos construcción, industrial y agrícola.
                </p>
                <p>
                  Acompañamos a nuestros clientes en la evolución de sus operaciones y ante los nuevos estándares de construcción y legislación sobre emisiones.
                </p>
              </div>
            </div>
            <div className="lg:col-span-7">
              <div className="relative aspect-[4/3] bg-white overflow-hidden border border-border-subtle">
                <img
                  alt="Parque vehicular JCB Azteca - Flota de maquinaria JCB lista para distribución en el sureste de México"
                  title="Parque vehicular JCB Azteca | Distribución en el sureste"
                  className="w-full h-full object-cover object-center"
                  src={ParqueVehicular2}
                  loading="lazy"
                  width="1200"
                  height="900"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-28 sm:py-36 bg-white">
        <div className="max-w-[1680px] mx-auto px-6 sm:px-12">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="font-display text-xs uppercase tracking-luxury text-jcb-yellow font-semibold block mb-3">
              Nuestra Historia
            </span>
            <h2 className="font-display text-3xl sm:text-5xl font-semibold text-dark-primary tracking-tight-headline uppercase">
              Hitos que marcaron el camino
            </h2>
            <p className="mt-4 text-text-muted">
              Más de 75 años de innovación, superando límites y construyendo el futuro.
            </p>
          </div>

          <div className="relative overflow-x-auto pb-4" role="region" aria-label="Línea de tiempo de la historia de JCB">
            <div className="flex gap-6 min-w-max px-4">
              {timeline.map((item, index) => (
                <div key={index} className="flex flex-col items-center w-64 flex-shrink-0">
                  <div className="w-full h-40 bg-surface-subtle rounded-lg overflow-hidden shadow-sm">
                    <img
                      src={item.img}
                      alt={item.alt}
                      title={`JCB ${item.year} | ${item.title}`}
                      loading="lazy"
                      width="256"
                      height="160"
                      className="w-full h-full object-cover object-center"
                    />
                  </div>

                  <div className="relative flex flex-col items-center mt-4 w-full">
                    {index !== timeline.length - 1 && (
                      <div className="absolute top-3 left-[50%] w-full h-0.5 bg-border-medium" aria-hidden="true"></div>
                    )}
                    <div className="relative z-10 w-8 h-8 bg-jcb-yellow rounded-full flex items-center justify-center border-4 border-white shadow-lg">
                      <span className="font-display text-[10px] font-bold text-dark-primary" aria-hidden="true">{index + 1}</span>
                    </div>
                  </div>

                  <span className="mt-2 font-display text-sm font-bold text-jcb-yellow">
                    {item.year}
                  </span>

                  <div className="mt-2 text-center">
                    <h3 className="font-display text-sm font-semibold uppercase tracking-wide text-dark-primary leading-tight">
                      {item.title}
                    </h3>
                    <p className="mt-1 text-xs text-text-muted leading-relaxed line-clamp-4">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-center mt-8">
            <span className="font-display text-[10px] uppercase tracking-luxury text-text-subtle flex items-center gap-2">
              <span className="material-symbols-outlined text-sm" aria-hidden="true">swipe</span>
              Desliza para ver más
            </span>
          </div>
        </div>
      </section>

      <section className="relative w-full py-32 sm:py-44 bg-dark-primary overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            alt="JCB Azteca - Maquinaria JCB en operación respaldando proyectos del sureste de México"
            title="Respaldo JCB Azteca | Más que maquinaria"
            className="w-full h-full object-cover object-center filter brightness-[0.35] contrast-[1.1]"
            src={HomeHeroPotencia}
            loading="lazy"
            width="1920"
            height="1080"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-6 sm:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <span className="font-display text-xs uppercase tracking-luxury text-jcb-yellow font-semibold mb-4 block">Respaldo continuo</span>
              <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-semibold uppercase text-white tracking-tight-headline leading-tight">
                Más que maquinaria. Un respaldo para tu operación.
              </h2>
              <p className="mt-6 text-base sm:text-lg text-neutral-300 font-light leading-relaxed">
                Desde la selección del equipo hasta las refacciones, mantenimiento y servicio, JCB AZTECA busca acompañar a sus clientes durante toda la operación de su maquinaria.
              </p>
              <div className="mt-10">
                <Link to="/services" className="inline-block font-display text-xs uppercase tracking-luxury font-semibold bg-white text-dark-primary hover:bg-jcb-yellow hover:text-dark-primary px-10 py-4 transition-all duration-300" title="Conoce los servicios de JCB Azteca">
                  Conoce nuestros servicios
                </Link>
              </div>
            </div>

            <div className="relative">
              <div className="aspect-video w-full bg-black/50 rounded-lg overflow-hidden shadow-2xl border border-white/10">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube-nocookie.com/embed/NgpzbbBS0_g?si=jUhK3CGIhQ9CO7Cu&autoplay=0&rel=0"
                  title="Video JCB Azteca - Respaldo y servicio para tu maquinaria JCB"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  loading="lazy"
                  className="w-full h-full"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-20 bg-white border-t border-border-subtle">
        <div className="max-w-[1680px] mx-auto px-6 sm:px-12 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-display text-3xl sm:text-4xl font-semibold uppercase tracking-tight-headline text-dark-primary leading-tight">
              ¿Necesitas maquinaria o servicio especializado?
            </h2>
            <p className="mt-4 text-base text-text-muted leading-relaxed">
              Contáctanos y encuentra la solución adecuada para las necesidades de tu operación.
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              <Link to="/machinery" className="font-display text-xs uppercase tracking-luxury font-semibold bg-jcb-yellow hover:bg-jcb-yellow-hover text-dark-primary px-8 py-4 transition-all duration-300" title="Ver catálogo de maquinaria JCB">
                Ver maquinaria
              </Link>
              <Link to="/contact" className="font-display text-xs uppercase tracking-luxury font-medium bg-dark-primary hover:bg-black text-white px-8 py-4 transition-all duration-300" title="Solicitar cotización JCB">
                Solicitar cotización
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;